angular.module('wbDashboard').controller('FundingRolloversPendingControllerAurea',
        ['$scope', '$uibModal', '$q', '$timeout', '$filter', 'User', 'Message', 'PlanService',
function ($scope, $uibModal, $q, $timeout, $filter, User, Message, PlanService) {

    $scope.pageData.canceling = {};
    $scope.documents = { files: null, lastFiles: [], badFiles: [], uploaded: false, uploading: false };
    $scope.stateDocuments = [];

    if ($scope.$state.current.name === 'base.funding.rollovers.pending.status') {
        setupStatusPage();
    }

    $scope.$watch(User.getOverview, function(overview) {
        $scope.overview = overview;
    });

    $scope.goNextStep = function(uuid) {
        var rollover;
        if (!uuid && $scope.rollover) {
            uuid = $scope.rollover.uuid;
        }
        if (uuid) {
            rollover = PlanService.user.getRollovers(uuid);
        } else {
            Message.set({
                text:"Couldn't find rollover at the moment. If you continue to have problems, please email support@axosinvest.com.",
                type: "warning"
            });
            return;
        }
        if ($scope.overview.pending_account && rollover.status === 'add-ira') {
            Message.set({
                text:"Unable to add an IRA while you have a pending account",
                type: "warning"
            });
            return;
        }

        $scope.pageData.sending = true;
        PlanService.user.nextRolloverStep(uuid).catch(function(response){
            var message = "Something went wrong, please try again. If you continue to have problems, please email support@axosinvest.com.";
            if (response && response.data && response.data.error) {
                message = response.data.error;
            }
            Message.set({
                text: message,
                type: "warning"
            });
            //doesn't hurt to continue through this part
        }).then(function() {
            return PlanService.user.retrieveRollovers(true);
        }).then(function() {
            if ($scope.$state.current.name === 'base.funding.rollovers.pending.status') {
                $scope.$state.go("^");
            }
            switch (rollover.status) {
                case 'add-ira':
                    User.retrieveOverview(true);
                    User.retrieveAllMilestones(true);
                    break;
            }

        }).finally(function() {
            $scope.pageData.sending = false;
        });
    };

    $scope.goToRetirement = function() {
        var retirement = User.getMilestoneByType('retirement');
        $scope.$state.go('base.milestone.overview', {msId:retirement.id});
    };

    $scope.clearBadFiles = function() {
        $scope.documents.badFiles.length = 0;
    };
    $scope.uploadDocs = function($files, $file, $newFiles, $duplicateFiles, $invalidFiles, $event) {
        var responsePromise, badFiles;

        // $scope.documents.lastFiles.length = 0;
        $scope.documents.lastFiles.push.apply($scope.documents.lastFiles, $scope.documents.files);

        ({promise: responsePromise, badFiles} = User.uploadDocuments($scope.documents.files, {rollover_id: $scope.rollover.uuid})); // jshint ignore:line


        $scope.documents.uploaded = false;
        $scope.documents.uploading = true;
        $scope.pageData.sending = true;
        responsePromise.then(function() {
            $scope.documents.uploaded = true;
        }).finally(function() {
            //$scope.documents.badFiles will be overwritten by ngf so have to add it here
            $scope.documents.badFiles.push.apply($scope.documents.badFiles, badFiles);
            for (var i=$scope.documents.lastFiles.length-1; i>=0; i--) {
                if (badFiles.indexOf($scope.documents.lastFiles[i]) > -1) {
                    $scope.documents.lastFiles.splice(i ,1);
                }
            }

            $scope.documents.uploading = false;
            $scope.pageData.sending = false;
        });
    };

    $scope.downloadSecureForm = function(rollover) {
        var key, filename;
        var transferFile = $filter('filter')(rollover.documents, {document_step: 'needs-transfer-form'});
        transferFile = transferFile.pop();
        if (!transferFile) {
            Message.set({
                text:"There is an issue with your transfer form, please email support@axosinvest.com.",
                type: "warning"
            });
            return;
        }
        key = transferFile.key;
        filename = transferFile.name;

        User.getDocumentUrl(key).then(function (response) {
            $scope.downloadUrl = response.data.response.s3url;
            $scope.downloadFilename = filename;

            var modalInstance = $uibModal.open({
                templateUrl: "modal-secure-rollover-download.tpl.html", //id of script tag in template
                scope: $scope,
                size: 'md',
                windowClass: 'confirm-modal secure-download-modal'
            });
            modalInstance.result.catch(angular.noop).finally(function() {
                $timeout(function() {
                    $scope.downloadUrl = null;
                    $scope.downloadFilename = null;
                });
            });

        });
    };
    $scope.cancelModal = function(rollover) {
        if ($scope.pageData.sending) return;

        $scope.rolloverCanceling = rollover;
        var modalInstance = $uibModal.open({
            templateUrl: 'modal-funding-rollover-cancel.tpl.html',
            scope: $scope,
            size: 'md',
            windowClass: 'confirm-modal modal-funding-rollover-cancel'
        });

        modalInstance.result.then(function () {
            //do a cancel thing
            $scope.pageData.canceling[rollover.uuid] = true;
            return PlanService.user.deleteRollover(rollover.uuid).then(function() {
                return PlanService.user.retrieveRollovers(true);
            }).then(function() {
                Message.set({
                    text: $scope.rolloverCanceling.source_broker_name +" "+ $filter('capitalize')($scope.rolloverCanceling.rollover_type) + " Successfully Canceled",
                    type: "success"
                });
            }).catch(function() {
                Message.set({
                    text:"Something went wrong, please try again. If you continue to have problems, please email support@axosinvest.com.",
                    type: "warning"
                });
            }).finally(function() {
                $scope.pageData.canceling[rollover.uuid] = false;
            });

        }).catch(angular.noop).finally(function() {
        });
    };

    $scope.stepsModal = function() {
        var modalInstance = $uibModal.open({
            templateUrl: 'modal-funding-rollover-steps.tpl.html',
            size: 'md',
            windowClass: 'confirm-modal modal-funding-rollover-steps'
        });

        modalInstance.result.then(function () {
        }).catch(angular.noop).finally(function() {
        });
    };

    function setupStatusPage() {
        var uuid = $scope.$stateParams.rollover_id;
        if (uuid) {
            $scope.rollover = PlanService.user.getRollovers(uuid);

            $scope.stateDocuments = $filter('filter')($scope.rollover.documents, {document_step: $scope.rollover.status});
            if ($scope.stateDocuments.length) {
                $scope.documents.uploaded = true;
            }

        }
        if ($scope.$stateParams.page !== $scope.rollover.status) {
            return $scope.$state.go(".", {page: $scope.rollover.status});
        }
    }

    var transitionDeregisterHook = $scope.$transitions.onSuccess({ to: "base.funding.rollovers.pending.status" }, function(trans) {
        return setupStatusPage();
    });
    $scope.$on('$destroy', function() {
        if (transitionDeregisterHook) {
            transitionDeregisterHook();
        }
    });



}]);
